import { markInitialised, setExpanded } from '../utils/dom'

let activeSearchContext = null
let documentKeydownBound = false

export default function initSearch() {
	const statusEl = document.querySelector('[data-search-status]')
	const toggles = document.querySelectorAll('[data-search-control="toggle"]')

	if (!statusEl || !toggles.length) {
		activeSearchContext = null
		document.body.classList.remove('search-panel-active')
		return
	}

	let lastTrigger = null

	const setSearchState = (isActive) => {
		const nextStatus = isActive ? 'active' : 'not-active'

		statusEl.setAttribute('data-search-status', nextStatus)
		statusEl.setAttribute('aria-hidden', isActive ? 'false' : 'true')
		document.body.classList.toggle('search-panel-active', isActive)
		toggles.forEach((toggle) => setExpanded(toggle, isActive))
	}

	const openSearch = (trigger = null) => {
		lastTrigger = trigger
		setSearchState(true)

		const input = statusEl.querySelector('input[type="search"], input[name="s"]')
		input?.focus({ preventScroll: true })
	}

	const closeSearch = () => {
		if (statusEl.getAttribute('data-search-status') !== 'active') return

		setSearchState(false)
		lastTrigger?.focus({ preventScroll: true })
	}

	document
		.querySelectorAll('[data-search-control="toggle"]')
		.forEach((toggle) => {
			if (!markInitialised(toggle, 'jsSearchToggle')) return

			toggle.addEventListener('click', () => {
				const current = statusEl.getAttribute('data-search-status')
				const isActive = current === 'active'

				if (isActive) {
					closeSearch()
				} else {
					openSearch(toggle)
				}
			})
		})

	activeSearchContext = {
		closeSearch,
	}

	if (!documentKeydownBound) {
		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape') {
				activeSearchContext?.closeSearch()
			}
		})
		documentKeydownBound = true
	}

	setSearchState(statusEl.getAttribute('data-search-status') === 'active')
}
